import { computed } from "@preact/signals-react"
import { analyzerCarPick } from "Pages/AnalyzersV2/@signals"
import { carPickBody } from "Pages/AnalyzersV2/@services/carPick"
import {
	acriss,
	analyzerDate,
	categories,
	currency,
	fuelPolicy,
	insurance,
	inTerminal,
	lengthRental,
	mainProvider,
	mainSite,
	mileage,
	offices,
	officesPickoff,
	prepaid,
	priceKpi,
	providers,
	reports,
	searchID,
	sites,
	transmission,
	webSuppliers
} from "@signals"
import { SEARCH_GROUP_BY } from "@constants"
import { TABLE_TAB_SELECTED } from "Pages/AnalyzersV2/@constants"

export const positionPayload = computed(() => ({
	reportExecutionID: reports.value,
	// This analyzer has no Min/Max switch: `DashboardPositionService` overrides
	// `price_keys` to `['min_price']`, so `tabKey` is inert here. Pinned rather
	// than read from the shared signal, which another analyzer may have left on
	// "max" earlier in the session.
	tabKey: TABLE_TAB_SELECTED.MIN,
	getDiffPriceChar: true,
	acriss: acriss.value,
	automatic: transmission.value,
	categoryID: categories.value,
	fuelPolicyID: fuelPolicy.value,
	providerID: providers.value,
	webSupplierID: webSuppliers.value,
	is_prepaid: prepaid.value,
	unlimited_km: mileage.value,
	groupBy: SEARCH_GROUP_BY.DAY,
	isDailyPrice: priceKpi.value,
	inTerminal: inTerminal.value,
	insurance: insurance.value,
	// Inert for this analyzer: `groupBySiteProvider` is only read by
	// `dor_lor/base_svc.py`, and DashboardPositionService extends
	// AnalyzerBaseService instead. Kept fixed to match the reference payload.
	groupBySiteProvider: true,
	siteID: sites.value,
	currency: currency.value,
	siteMainID: mainSite.value,
	providerMainID: mainProvider.value,
	isNewVersion: true,
	searchID: searchID.value,
	officePickupID: !searchID.value ? offices.value : null,
	officeDropoffID: officesPickoff.value,
	lor: lengthRental.value,
	pickupDate: analyzerDate.value,
	reportType: 'position',
	// the Cars selector above the table (CU-869fmpqfm): `carPickType` + `carPick`, or nothing for All cars
	...carPickBody(analyzerCarPick.value),
}))
